import { EboObjectTimePeriod } from '../base-classes/ebo-object-time-period';
import { Truck } from '../truck/truck';
import { Asset } from './asset';

export class AssetAssignment extends EboObjectTimePeriod {
  truckID: string;
  truck: Truck;
  assetID: string;
  asset: Asset;
  comment: string;

  constructor(jsonData?: Partial<AssetAssignment>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.truck) {
        this.truck = new Truck(jsonData.truck);
      }
      if (jsonData.asset) {
        this.asset = new Asset(jsonData.asset);
      }
    }
  }

  toShortString(format?: string): string {
    if (format == 'alias') return `${this.truck ? this.truck.toShortString() : 'Unknown'}`;
    return `${this.truck ? this.truck.toShortString() : 'Unknown'}-${
      this.asset ? this.asset.toShortString() : 'Unknown'
    }`;
  }

  toTimeLineView(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}: ${
      this.truck ? this.truck.toShortString() : 'Unknown'
    }`;
  }
}
